import {Logger} from '#core/utils/logger.js';

const log = Logger('DBX-16794');

const USER_SETTINGS_KEY = 'userSettings';
const TIME_OFFSET_KEY = 'timeOffset';
const MIGRATION_KEY = 'DBX-16794-remove-legacy-time-offset';
const LEGACY_DEFAULT_TIME_OFFSET = -6;

export function removeLegacyTimeOffset() {
    try {
        if (window.localStorage.getItem(MIGRATION_KEY)) {
            return;
        }

        const rawUserSettings = window.localStorage.getItem(USER_SETTINGS_KEY);

        if (rawUserSettings) {
            const userSettings = JSON.parse(rawUserSettings);

            if (
                typeof userSettings === 'object' &&
                userSettings !== null &&
                userSettings[TIME_OFFSET_KEY] === LEGACY_DEFAULT_TIME_OFFSET
            ) {
                delete userSettings[TIME_OFFSET_KEY];

                window.localStorage.setItem(USER_SETTINGS_KEY, JSON.stringify(userSettings));

                log.info('Removed legacy default timeOffset from userSettings.');
            }
        }

        window.localStorage.setItem(MIGRATION_KEY, 'done');
    } catch (error) {
        log.error('Failed to remove legacy timeOffset from userSettings.', error);
    }
}
